import { format } from 'date-fns';
import { HeaderContainer } from './styles';

interface IHeader {
  user: string;
  createdAt: Date;
  type: 'answer' | 'reclamation';
  channel?: string;
}

export default function Header({ user, createdAt, type, channel }: IHeader) {
  const formattedDate = format(new Date(createdAt), 'dd/MM/yyyy \'às\' HH:mm');

  return (
    <HeaderContainer type={type}>
      <header>
        <div className="avatar">
          <span>{user.charAt(0)}</span>
        </div>
        <div className="user-info">
          <strong>{user}</strong>
          <div className="meta">
            <span>{formattedDate}</span>
            {(channel && type === 'reclamation') && (
              <span className="channel-badge">{channel.replace('Site', 'RH')}</span>
            )}
          </div>
        </div>
      </header>
    </HeaderContainer>
  );
}
